// Copyright (c) 2018 Deere & Company

import {translate} from '../../../shared/services/translation-service';

export const getRegistrationReviewColumns = () => ({
    listColumns: [
        {
            id: 'pin',
            key: translate('PIN')
        },
        {
            id: 'dealer',
            key: translate('DEALER_LOCATION')
        },
        {
            id: 'registered',
            key: translate('REGISTERED')
        },
        {
            id: 'error',
            key: translate('ERROR')
        }
    ],
    listId: 'registrations'
});



// WEBPACK FOOTER //
// ./src/product/registration-review/services/excel-columns.js